module.exports = "<div>\n  <app-loader *ngIf=\"show\"></app-loader>\n  <router-outlet></router-outlet>\n</div>"